import { device } from '@accedo/xdk-core'
import { RenderableComponentMetadataEnum } from '../../types/flo-enums'
import { getAuthToken, getRefreshToken, getUserData } from '../authentication'
import { getAnonymousId } from '../segmentAnalytics'

export default class FloVizbeeConverters {
  static async toVideoInfo(playerModel, currentTime, imgUrl, videoUrl) {
    const streamId =
      playerModel.content_metadata.streams?.[0]?.stream_id ?? playerModel.content_metadata.stream_id
    const eventId = playerModel.analytics?.extra_context?.live_id
    const castClient = device.platform
    const title =
      playerModel.content_metadata.title ?? playerModel?.analytics?.video_analytics?.event_name
    const subtitle = playerModel.content_metadata.stream_name
    const streamName = `${title}${subtitle ? ' | ' : ''}${subtitle ?? ''}`
    const sportsVertical = playerModel.analytics?.site_name
    const viewingMode = playerModel?.analytics?.video_analytics?.viewing_mode
    const node_id = playerModel.analytics?.node_id
    const premium = playerModel.analytics?.is_premium ? '1' : '0'
    const { user_id } = getUserData() ?? {}
    const segmentAnonymousId = await getAnonymousId()

    const youbora = {
      eventId: eventId?.toString(),
      castClient: castClient,
      streamId: streamId?.toString(),
      eventName: title,
      streamName: streamName,
      sportsVertical: sportsVertical,
      viewingMode: viewingMode,
      segmentAnonymousId: segmentAnonymousId,
      numericUserId: user_id?.toString(),
      nodeId: node_id,
      premium: premium,
    }

    const customStreamInfo = {
      youbora: youbora,
      refreshToken: getRefreshToken(),
      authToken: getAuthToken(),
    }

    const entity_id = playerModel.analytics?.entity_id
    const isLive = streamId >= 0
    const startTime = isLive ? 0 : currentTime
    const guid = [entity_id ?? node_id, title, subtitle, imgUrl, isLive ? 'live' : 'vod']

    const vInfo = new vizbee.continuity.messages.VideoInfo()
    vInfo.guid = guid.join('<>')
    vInfo.isLive = isLive
    vInfo.startTime = startTime * 1000
    vInfo.videoUrl = videoUrl
    vInfo.imgUrl = imgUrl
    vInfo.title = title
    vInfo.subtitle = subtitle ?? ''
    vInfo.customStreamInfo = customStreamInfo
    vInfo.customMetadata = {}
    vInfo.desc = ''

    return vInfo
  }

  /**
   * Converts Vizbee's VideoInfo to a PlayerModel, which the player can use to initiate playback
   * @param videoInfo - Vizbee's VideoInfo containing data from the casted video to the TV device
   * @returns a PlayerModel object, that can be used to initiate playback
   */
  static fromVideoInfo(videoInfo) {
    const node_id = videoInfo.customStreamInfo?.youbora?.nodeId
    const live_id = videoInfo.customStreamInfo?.youbora?.eventId
    const stream_id = videoInfo.customStreamInfo?.youbora?.streamId
    const entity_id = videoInfo.isLive ? videoInfo.guid.split('<>')[0] : node_id
    const routeId = videoInfo.isLive ? `tv-event-card-${stream_id}` : `tv-vod-card-${node_id}`
    const vertical_name = videoInfo.customStreamInfo?.youbora?.sportsVertical
    const cast_client = videoInfo.customStreamInfo?.youbora?.castClient
    const stream_name = videoInfo.isLive ? videoInfo.subtitle : null

    const analytics = {
      entity_id: entity_id,
      extra_context: {
        live_id: live_id,
      },
      video_analytics: {
        vertical_name: vertical_name,
        cast_client: cast_client,
      },
    }

    const content_metadata = {
      type: videoInfo.isLive
        ? RenderableComponentMetadataEnum.Stream
        : RenderableComponentMetadataEnum.Vod,
      playlist: videoInfo.isLive ? '' : videoInfo.videoUrl,
      progress_seconds: videoInfo.startTime / 1000,
      title: videoInfo.title,
      streams: [],
      stream_id: stream_id,
      stream_name: stream_name,
    }

    const playerModel = {
      analytics: analytics,
      type: null,
      style: null,
      id: routeId,
      content_metadata: content_metadata,
      node_id: node_id,
      title: content_metadata.title,
      playlist: null,
      authDeeplinked: false,
      videoInfo,
    }

    return playerModel
  }
}
